export default __webpack_public_path__ + "static/media/rotate.871562fd.svg";